/** @file Builds one animation.setCurve command call for frames of one curve timeline. */
import type { CommandCall, Curve } from '@pose2d/format/types';
import type { CurveRef } from './curveTypes';

/** `animation.setCurve` with ids for animation and target; frames must be existing key frames, ascending. */
export function setCurveCall(ref: CurveRef, frames: number[], curve: Curve): CommandCall {
  return { name: 'animation.setCurve', input: { animation: ref.animation, channel: ref.channel, target: ref.target, curve, frames } };
}
